export class SleepUtils {
  static async sleep(ms: number) {
    return new Promise<boolean>(resolve => setTimeout(resolve, ms));
  }
}